var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { $router } from 'ziphy-web-shared/basic/utils/router';
import { routeActions } from '@root/client/src/config/routeActions';
import $livequeueChatStore from '@store/livequeueChatStore';
import { useConsultationChatMessages, } from '../../consultations/hooks/useConsultationChatMessages';
import OrderItem from '../OrderItem/ui/OrderItem';
import styles from './OrdersList.module.scss';
export const OrdersList = ({ orders, totalCount }) => {
    const { t } = useTranslation();
    const [consultations, setConsultations] = useState(orders);
    useEffect(() => {
        setConsultations(orders);
    }, [orders]);
    useEffect(() => {
        $livequeueChatStore.getSubscriptions({ chat_ids: orders.map((order) => order.chat_id) });
    }, []);
    const onUpdateConsultationMessage = useCallback((msg) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const chatId = (_a = msg === null || msg === void 0 ? void 0 : msg.payload) === null || _a === void 0 ? void 0 : _a.chat_id;
        if (chatId) {
            $livequeueChatStore.getSubscriptionsForChats([chatId]);
        }
    }), []);
    useConsultationChatMessages({ onMessage: onUpdateConsultationMessage });
    const handleChatClick = (order) => {
        $router.executeAutoTarget(routeActions.CLIENT_CHAT({
            orderId: order._id,
            chatId: order.chat_id,
        }), { type: 'replace' });
    };
    return (_jsxs("div", Object.assign({ className: styles.ordersList }, { children: [totalCount > 0 && (_jsx("div", Object.assign({ className: styles.count }, { children: t('label.orders_found', { count: totalCount }) }))), _jsx("div", Object.assign({ className: styles.orders }, { children: consultations.map((order) => (_jsx(OrderItem, { order: order, onChatClick: () => handleChatClick(order) }, order._id))) }))] })));
};
export default observer(OrdersList);
